import { CRM_TOKEN } from '@private-crm-app/constants';
import { validateCRMToken } from '@private-crm-app/requests/submission';
import { clearCrmTokenSession, persistCrmTokenSession } from '@private-crm-app/utils';

export type SyncCrmTokenSessionResult =
  | { ok: true; switchedToken: boolean }
  | { ok: false; switchedToken: false };

/**
 * Re-validate a CRM token and persist canonical session fields (including Agency.name).
 * Always hits the API when called so returning sessions with the same token refresh
 * agency_name instead of keeping a stale CRM product name.
 * Clears the session when the CRM is inactive or missing agencyId.
 */
export const syncCrmTokenSession = async (crmToken: string): Promise<SyncCrmTokenSessionResult> => {
  const existingToken = localStorage.getItem(CRM_TOKEN);
  const response = await validateCRMToken(crmToken);

  if (!response?.agencyId || !response.isActive) {
    clearCrmTokenSession();
    return { ok: false, switchedToken: false };
  }

  persistCrmTokenSession(crmToken, response);

  return {
    ok: true,
    switchedToken: crmToken !== existingToken,
  };
};
